<template>
  <v-card>
    <v-card-title
      ><b>Contacts</b>
      <v-spacer></v-spacer>
      <v-btn
        icon
        small
        v-if="!creating"
        class="float-sm-right mt-2 mx-2"
        @click="$emit('createReq')"
      >
        <v-icon class="ml-1">mdi-plus-box-outline</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-list>
        <Alert v-if="showAlert" text="Contact updated" type="success" />
        <v-list-item
          v-for="(contact, index) in contactsData"
          :key="contact.id"
          class="card-shadow border-radius-xl"
        >
          <v-list-item-content>
            <v-row>
              <v-col cols="4">
                <EditableField
                  :value="contact.name"
                  :keyPath="`contactsData.${index}.name`"
                  label="Name"
                  :editing="editing[index]"
                  @save="updateApiData"
                >
                  <template #label>
                    <span class="d-inline-flex align-center mr-2">
                      <v-icon small class="text-h5 mr-1">mdi-account</v-icon>
                      <span class="mb-2 text-primary">{{ label }}</span>
                    </span>
                  </template>
                  <template #value>
                    <span
                      class="
                        text-h5
                        d-inline-flex
                        align-center
                        font-weight-bold
                      "
                    >
                      {{ contact.name }}
                    </span>
                  </template>
                </EditableField>
                <EditableField
                  :value="contact.email"
                  :keyPath="`contactsData.${index}.email`"
                  label="Email"
                  :editing="editing[index]"
                  @save="updateApiData"
                  hideLabel
                >
                  <template #value>
                    <span>
                      <a :href="`mailto:${contact.email}`">{{
                        contact.email
                      }}</a>
                    </span>
                  </template>
                </EditableField>
                <EditableField
                  :value="contact.phone_number"
                  :keyPath="`contactsData.${index}.phone_number`"
                  label="Phone"
                  :editing="editing[index]"
                  @save="updateApiData"
                />
              </v-col>
              <v-col cols="4">
                <EditableField
                  :value="contact.description"
                  :keyPath="`contactsData.${index}.description`"
                  label="Description"
                  :editing="editing[index]"
                  @save="updateApiData"
                />
                <EditableField
                  :value="contact.role"
                  :keyPath="`contactsData.${index}.role`"
                  label="Role"
                  :editing="editing[index]"
                  @save="updateApiData"
                />
              </v-col>
              <v-col cols="4">
                <v-btn
                  icon
                  small
                  v-if="!editing[index]"
                  @click="deleteContact(index)"
                  class="float-sm-right mt-2 mx-2"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  class="float-sm-right mt-2 mx-2"
                  @click="toggleEdit(index, contact)"
                >
                  <v-icon>{{
                    editing[index] ? 'mdi-content-save' : 'mdi-account-edit'
                  }}</v-icon>
                </v-btn>
                <v-btn
                  icon
                  small
                  v-if="editing[index]"
                  @click="cancelEdit(index)"
                  class="float-sm-right mt-2 mx-2"
                >
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
  import Alert from '@/components/Alert.vue'
  import EditableField from '../../components/EditableField.vue'
  import { setNestedValue } from '@/util/helpers.js'

  export default {
    name: 'ClientContacts',
    components: { EditableField, Alert },
    props: {
      contacts: {
        type: Array,
        default: () => [],
        required: true,
      },
      creating: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        editing: [],
        contactsData: this.contacts,
        showAlert: false,
      }
    },
    methods: {
      toggleEdit(index) {
        if (this.editing[index]) {
          this.updateContact(index)
        }
        this.$set(this.editing, index, !this.editing[index])
      },
      updateApiData(details) {
        setNestedValue(this, details.keyPath, details.value)
      },
      updateContact(index) {
        setTimeout(() => {
          let details = { ...this.contactsData[index] }
          let contactId = details['id']
          for (let key of [
            'created_at',
            'updated_at',
            'deleted_at',
            'client_id',
            'id',
          ])
            delete details[key]
          this.apiModifyClientContact(contactId, details)
            .then(response => {
              this.contactsData[index] = response
              this.showAlert = true
            })
            .catch(error => {
              console.log(error)
            })
        }, 200)
      },
      cancelEdit(index) {
        this.contactsData[index] = { ...this.contacts[index] }
        this.$set(this.editing, index, false)
      },
      deleteContact(index) {
        let contactId = this.contactsData[index].id
        this.apiDeleteClientContact(contactId)
          .then(() => {
            this.contactsData.splice(index, 1)
            this.editing.splice(index, 1)
            this.showAlert = true
          })
          .catch(error => {
            console.log(error)
          })
      },
    },
    watch: {
      contacts: {
        handler(newContacts) {
          this.editing = newContacts.map(() => false)
          this.contactsData = newContacts
        },
        immediate: true,
      },
    },
  }
</script>
